import { createSlice } from '@reduxjs/toolkit'
import {postItvList,postItvCount} from "./thunks"

const initialState= {
  list: {
    pageIndex: 0,
    totalRecords: 50,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: []
  },
  loading: "idle",
  loadingCount: "idle",
  error: null }

const itvSlice = createSlice({
  name: 'itvs',
  initialState,
  reducers: {
    clearItvError:(state)=>{
      state.error= null
    },
    setItvFilters:(state, action)=>{
      state.filters= action.payload
    }
  },
  extraReducers: {
    [postItvList.pending]: (state) => {
        state.loading = "loading";
        state.error = null
      },
    [postItvList.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.list.elements = action.payload.elements;
    },
    [postItvList.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message
    },
    [postItvCount.pending]: (state) => {
      state.loadingCount = "loading"; 
      state.error = null
    },
    [postItvCount.fulfilled]: (state, action) => {
      state.loadingCount = "succeeded";
      state.list.pageIndex = action.payload.pageIndex;
      state.list.totalRecords = action.payload.totalRecords;
      state.list.totalPages = action.payload.totalPages;
      state.list.hasPreviousPage = action.payload.hasPreviousPage;
      state.list.hasNextPage =action.payload.hasNextPage;

    },
    [postItvCount.rejected]: (state, action) => {
      state.loadingCount = "failed"; 
      state.error = action.error.message
    },

  }
})

export const {clearItvError, setItvFilters} = itvSlice.actions;

export default itvSlice.reducer
